// Ruta: apps/cms/src/main.tsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@heyshaker/api-client'
import { AuthProvider } from '@heyshaker/auth'
import { ErrorBoundary } from '@heyshaker/ui'
import '@heyshaker/ui/styles'
import { i18n, telemetry, patchFetchWithTelemetry } from '@heyshaker/shared'
import App from './App.js'

// Ensure i18n is initialized
void i18n

// ── Telemetry initialization (HAL-FE-002) ───────────────────────────────────
telemetry.init({
  enabled: true,
  endpoint: `${import.meta.env.VITE_BFF_URL ?? ''}/api/v1/telemetry`,
  appName: 'cms',
  debug: import.meta.env.DEV,
})
patchFetchWithTelemetry()

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element not found')

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
)
